<div class="pilot-pay-categories-details">
	<form [formGroup]="form">
		<div class="pp-toolbar">
			<div fxFlex fxLayoutAlign="center center" fxLayoutGap="5px" fxLayout.xs="column" fxLayout.lg="row">
				<div>
					<span class="vertical-middle calendar-helper-text">Change goes into effect on: </span>
					<button type="button" class="button-date-picker" mat-button>
						<input
							name="date"
							required
							[matDatepicker]="datepicker"
							[min]="currentMonth"
							formControlName="effectiveDate"
						/>
						<mat-datepicker-toggle matSuffix [for]="datepicker">
							<mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
						</mat-datepicker-toggle>
						<mat-datepicker
							#datepicker
							(monthSelected)="chosenMonthHandler($event, datepicker)"
							startView="year"
						></mat-datepicker>
					</button>
				</div>
				<div fxFlex></div>
				<div fxLayoutGap="5px" fxLayout.xs="row">
					<button
						*ngIf="form.valid"
						class="form-button"
						color="blue"
						mat-raised-button
						(click)="form.valid && createPayScaleSetting()"
					>
						Save
					</button>
				</div>
			</div>
		</div>
		<div class="mt-1 mb-1">
			<div class="details-form">
				<div fxFlex.gt-sm="55%" fxFlex="100">
					<mat-card>
						<mat-card-title>Global Pay Settings</mat-card-title>
						<hr />
						<mat-card-content class="card-content">
							<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
								<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
									<input
										required
										formControlName="loadPayRate"
										matInput
										decimalOnly="twoDigitDecimalNumber"
										type="text"
										placeholder="Load Pay"
									/>
								</mat-form-field>
							</div>
							<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
								<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
									<input
										required
										formControlName="perDiemRate"
										matInput
										decimalOnly="twoDigitDecimalNumber"
										type="text"
										placeholder="Per Diem Rate"
									/>
								</mat-form-field>
							</div>
							<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
								<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
									<input
										required
										formControlName="apBonusPercentage"
										matInput
										decimalOnly="twoDigitDecimalNumber"
										type="text"
										placeholder="Constant A&P Bonus"
									/>
								</mat-form-field>
							</div>
							<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
								<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
									<input
										required
										formControlName="phoneStipendAmount"
										matInput
										decimalOnly="twoDigitDecimalNumber"
										type="text"
										placeholder="Phone Stipend Amount"
									/>
								</mat-form-field>
							</div>
							<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
								<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
									<input
										required
										formControlName="instructFlatRate"
										matInput
										decimalOnly="twoDigitDecimalNumber"
										type="text"
										placeholder="Instructor Flat Rate"
									/>
								</mat-form-field>
							</div>
						</mat-card-content>
					</mat-card>
				</div>
			</div>
		</div>
	</form>
	<div fxLayout="row" *ngIf="payScaleGlobalSettingChanges && payScaleGlobalSettingChanges.length">
		<div fxFlex.gt-sm="100%" fxFlex="100">
			<mat-card class="expander">
				<mat-card-title>
					<div>Future Changes</div>
					<div fxFlex></div>
					<button
						type="button"
						mat-icon-button
						class="ml-1"
						*ngIf="payScaleGlobalSettingChanges && payScaleGlobalSettingChanges.length"
						(click)="deletePayScaleGlobalSettingScheduledChanges()"
					>
						<mat-icon class="grey">delete</mat-icon>
					</button>
					<button
						type="button"
						mat-icon-button
						class="ml-1"
						(click)="futureChangesToggle = !futureChangesToggle"
					>
						<mat-icon *ngIf="!futureChangesToggle">keyboard_arrow_down</mat-icon>
						<mat-icon *ngIf="futureChangesToggle">keyboard_arrow_up</mat-icon>
					</button>
				</mat-card-title>
				<hr />
				<div [hidden]="!futureChangesToggle">
					<app-changes-display [history]="payScaleGlobalSettingChanges"></app-changes-display>
				</div>
			</mat-card>
		</div>
	</div>
	<div fxLayout="row" *ngIf="payScaleGlobalSettingHistory && payScaleGlobalSettingHistory.length">
		<div fxFlex.gt-sm="100%" fxFlex="100">
			<mat-card class="expander">
				<mat-card-title>
					<div>History</div>
					<div fxFlex></div>
					<button type="button" mat-icon-button class="ml-1" (click)="historyToggle = !historyToggle">
						<mat-icon *ngIf="!historyToggle">keyboard_arrow_down</mat-icon>
						<mat-icon *ngIf="historyToggle">keyboard_arrow_up</mat-icon>
					</button>
				</mat-card-title>
				<hr />
				<div [hidden]="!historyToggle">
					<app-changes-display [history]="payScaleGlobalSettingHistory"></app-changes-display>
				</div>
			</mat-card>
		</div>
	</div>
</div>
